<template>
  <div class="outer-wrap">
    <Sidebar
      v-if="this.getStructureDetails"
      :show="showSidebar"
      :adminRights="userHasAdminRight"
      :sensors="this.getStructureDetails.sensors"
      @sidebartoggle="showSidebar = !showSidebar"
      @settingstoggle="
        showSettings = !showSettings;
        showMonitor = false;
        showSidebar = false;
        showAnalogNode = false;
      "
      @monitortoggle="
        showMonitor = !showMonitor;
        showSettings = false;
        showSidebar = false;
        showAnalogNode = false;
      "
      @analog-node-toggle="
        showAnalogNode = !showAnalogNode;
        showMonitor = false;
        showSettings = false;
        showSidebar = false;
      "
    />
    <!-- Navigation Bar -->
    <div id="navbar">
      <NavBar v-show="true" @logout="this.logout" @sidebartoggle="showSidebar = !showSidebar" />
      <div id="general-info">
        <!-- Selezione Struttura -->
        <BridgeOverview
          id="bridge-ow"
          :bridges="this.getStructures"
          :selectedBridge="this.getStructureDetails"
          v-if="this.loaded && this.getStructureDetails"
          @struct-selected="selectStructure"
        />
        <top-sensor-select @type-selected="selectType" :sensors="this.getSensors" :selectedType="this.actualSensorType" v-if="this.getSensors.length > 0" />
      </div>
    </div>
    <div class="stat" id="page-wrap">
      <!-- Settings -->
      <transition name="settings">
        <Settings id="set" v-if="showSettings" :selectedStructure="this.getStructureDetails" @settingstoggle="showSettings = !showSettings" />
      </transition>
      <!-- Monitor -->
      <transition name="settings">
        <Monitor id="monitor" v-if="showMonitor" :selectedStructure="this.getStructureDetails" @monitortoggle="showMonitor = !showMonitor" />
      </transition>
      <!-- Analog Node -->
      <transition name="settings">
        <AnalogNode
          id="analog-node"
          v-if="this.getStructureDetails && showAnalogNode && userHasAdminRight"
          :selectedStructure="this.getStructureDetails"
          @close-me="showAnalogNode = false"
          @need-refresh="this.fetchStructureData"
        />
      </transition>
      <!-- Loading -->
      <transition name="load">
        <LoadingLogo v-if="!this.loaded" />
      </transition>
      <div class="container" v-if="validSensors.length > 1">
        <double-sensors-select :sensorsType="actualSensorType" v-if="actualSensorType === 'deck'" />
        <densProb :sensorsType="actualSensorType" v-if="actualSensorType === 'deck'" />
        <!-- Blocco Anomalie -->
        <anomaly v-if="actualSensorType && actualSensorType === 'deck'" />
        <!-- Blocco FreqCluster -->
        <group-select :sensorsType="actualSensorType" v-if="actualSensorType" />
        <FreqCluster v-if="loaded" :sensorsType="actualSensorType" graphuid="abcd1234" />
        <mod-freqs graphuid="sdf2342" v-if="getSelectedGroupNumber && actualSensorType" :sensorsType="actualSensorType" />
      </div>
      <div class="warning-container" v-else>
        <h2 v-if="loaded">Sensori non presenti</h2>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import TopSensorSelect from "../components/ui/TopSensorSelect.vue";
import doubleSensorsSelect from "../components/modules/stats/doubleSensorsSelect";
import groupSelect from "../components/modules/stats/groupSelect";
import densProb from "../components/modules/stats/densProb.vue";
import anomaly from "../components/modules/stats/anomaly.vue";
import FreqCluster from "../components/modules/stats/FreqCluster.vue";
import modFreqs from "../components/modules/stats/modFreqs";
import BridgeOverview from "../components/ui/BridgeOverview.vue";
import NavBar from "../components/ui/NavigationBar.vue";
import Sidebar from "../components/ui/Sidebar.vue";
import Settings from "./Settings";
import AnalogNode from "../views/AnalogNode";
import Monitor from "./Monitor";
import Footer from "../components/ui/Footer";
import LoadingLogo from "../components/ui/LoadingLogo";
import $ from "jquery";

import { mapGetters, mapActions } from "vuex";
import DoubleSensorsSelect from "../components/modules/stats/doubleSensorsSelect.vue";
import ModFreqs from "../components/modules/stats/modFreqs.vue";

export default {
  name: "app",
  data() {
    return {
      // True when api data is fetched
      loaded: false,
      showSidebar: false,
      showSettings: false,
      showMonitor: false,
      showAnalogNode: false,
      actualSensorType: null,
    };
  },
  components: {
    TopSensorSelect,
    doubleSensorsSelect,
    groupSelect,
    densProb,
    anomaly,
    FreqCluster,
    modFreqs,
    NavBar,
    BridgeOverview,
    Sidebar,
    Settings,
    AnalogNode,
    Monitor,
    Footer,
    LoadingLogo,
    DoubleSensorsSelect,
    ModFreqs,
  },
  computed: {
    ...mapGetters("structure", ["getStructures", "getSensors", "getSelectedStructure", "getStructureDetails"]),
    ...mapGetters({
      getSelectedGroupNumber: "FDD/getSelectedGroupNumber",
    }),
    userHasAdminRight() {
      return !this.getUserType || this.getUserType === "standard";
    },
    validSensors: function () {
      return this.getSensors.filter((sensor) => sensor.type === "deck" || sensor.type === "accelerometer");
    },
    isLambro() {
      return this.getSensors ? this.getSensors.some((sn) => sn.eui === "C0EE400001015144") : false;
    },
  },
  methods: {
    ...mapActions({
      fetchStructures: "structure/fetchStructures",
      fetchStructureData: "structure/fetchStructureData",
      selectStructure: "structure/selectStructure",
      setDensProb1Sens: "densProb1/setSelectedSensor",
      setDensProb2Sens: "densProb2/setSelectedSensor",
    }),
    ...mapActions("auth", ["logout"]),
    logoutSession: function () {
      this.logout();
    },
    selectType(type) {
      this.actualSensorType = type;
    },
    setupNavigationSticky: function () {
      // Setta l'hiding automatico della Navigation Bar
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos - currentScrollPos > 0) {
          $("#navbar").css("-webkit-transform", "translateY(0px");
          $("#navbar").css("transform", "translateY(0px");
        } else {
          if (currentScrollPos > 50) {
            /*             $("#navbar").css("-webkit-transform", "translateY(-110px");
            $("#navbar").css("transform", "translateY(-110px"); */
            $("#navbar").css("-webkit-transform", "translateY(-111px");
            $("#navbar").css("transform", "translateY(-111px");
          }
        }
        prevScrollpos = currentScrollPos;
      };
    },
  },
  watch: {
    getSelectedStructure: {
      handler: async function (newValue) {
        if (newValue) {
          this.loaded = false;
          await this.fetchStructureData();
          this.loaded = true;
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await this.fetchStructures();
    if (!this.getSelectedStructure) {
      await this.selectStructure(this.getStructures[0]);
    }
    this.setupNavigationSticky();
  },
};
</script>

<style scoped>
* {
  font-size: 1em;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
}
/* NavBar */
#navbar {
  transition: transform 0.3s;
  position: fixed;
  width: 100%;
  min-width: 840px;
  z-index: 999999;
}
#general-info {
  height: 60px;
  background-color: transparent;
  width: 100%;
  top: 50px;
  left: 0;
  position: absolute;
  -webkit-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
}

#bridge-ow {
  max-width: 100vw;
}
.stat {
  position: absolute;
  display: grid;
  background-color: rgb(32, 34, 47);
  font-size: 1em;
  padding-top: 170px;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  width: 100%;
  right: 0px;
  /* Transizioni usate per la Sidebar */
  -webkit-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
}

/* Tra 600 e 1499 */
@media all and (max-width: 1799px) and (min-width: 300px) {
  .stat {
    font-size: 0.8em;
  }
}

/* Loading Transition */
.load-enter,
.load-leave-to {
  opacity: 0;
}
.load-enter-active {
  transition: all 0.3s ease;
}
.load-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

#set {
  z-index: 12;
}

#monitor {
  z-index: 12;
}
</style>
